import { round } from "./index";

const formattedRound = value => {
  return round(value, 2).toFixed(2);
};

export default formattedRound;
